module.exports = __webpack_public_path__ + "media/images/flags/1x1/slb-a8ff282d0ed95f35720346d00ad0baf9.svg";